require('./hoverEditDialog.less');


var Marionette = require('marionette'),
    $ = require('jquery'),
    _ = require('underscore'),
    fvChannel = require('glRadio').channel('FV');


var instVars = {

    parent: null,
    $opener: null, // Note: this can be null in the case of full page redactions

    ChildViewConstructor: null,
    childView: null,
    childViewOptions: null,

    //cached value of the height of the button opener used in setPostion
    _openerHt: null,
    _openerWt: null,

    // cache values when put in DOM -- assumes view dimensions are static
    height: null,
    width: null

};



module.exports = Marionette.ItemView.extend({

    template: false,

    className: 'shape-hover-edit-dialog',

    initialize: function(options) {

        var $opener = options.$opener;

        _.extend( this, instVars, _.pick( options, 'parent', '$opener' ), {
            _openerHt: $opener ? parseInt( $opener.attr('height') ) : 0,
            _openerWt: $opener ? parseInt( $opener.attr('width') ) : 0
        });

        /* init the child view */
        this.ChildViewConstructor = options.dialogConstructor;
        this.childViewOptions = options.dialogOptions;

        this.childView = new this.ChildViewConstructor(
            this.childViewOptions
        );

        this.bindEntityEvents( this.parent, this.parentSubs );

        _.bindAll(this, '_setPosition' );
        $(window).on( 'resize scroll', this._setPosition );

    },

    // Really render the childView and attach the childView
    // Since el is the only region, don't need a LayoutView ( could be a region )
    onRender: function() {

        this.$el.append( this.childView.render().el );

    },
    /* Called after render from parent and after appended to DOM */
    onShow: function() {

        this.height = this.$el.outerHeight();
        this.width = this.$el.outerWidth();
        this._setPosition();

        /* Forward to childView */
        this.childView.triggerMethod('show');

    },

    parentSubs: {
        'shape.toggleFadeDialog':               '_fadeToggleDialog',
        'shape.buttonSet.postMove':             '_setPosition', // (position after placement of $opener)
        'shape.repositionShapeDialog':          '_setPosition' // overflow scroll, side panel move, side panel open/close, toggle full screen
    },

    events: {
        'click'                     : '_stopPropagation',    //body now has onclick event...
        'mouseup'                   : '_stopPropagation'
    },
    /* dir must be: In or Out */
    _fadeToggleDialog: function(dir, duration) {
        this.$el['fade' + dir](duration);
    },

    /* Move, Scale, Scroll -- should also be window resize, viewer panel moving, etc */
    _setPosition: function() {

        if (!this.$opener)
            return;

        var $win = $(window),
            $oOffset = this.$opener.offset();

        var top = $oOffset.top + this._openerHt - $win.scrollTop(),
            left = $oOffset.left - $win.scrollLeft();

        // flip the dialog if its bottom exceeds the bottom of the browser window
        if ( top + this.height > $win.height() ) {
            top -= this.height + this._openerHt;
            left += !this.parent.btnSet.isFlippedHorizontally // quick hack, should really get from a shape model or something ..
                ? this._openerWt
                : (-1 * this.width);
        }

        this.$el.css({
            top: top,
            left: left
        });

    },
    _stopPropagation: function(e) {

        e.stopImmediatePropagation();

    },
    onBeforeDestroy: function() {

        this.childView.destroy();

        $(window).off('resize scroll', this._setPosition);
        this.unbindEntityEvents(this.parent, this.parentSubs);

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/hoverEditDialog.js
 ** module id = 213
 ** module chunks = 0
 **/